module.exports = __webpack_public_path__ + "img/year-bg.adee34fa.png";